import React from 'react';

import { useLazyLoadQuery } from 'react-relay';
import { graphql } from 'relay-runtime';

import PartialPrefillInformationPage from './PartialPrefillInformationPage';
import PrefillInformationPage from './PrefillInformationPage';
import { PersonalInformationPagePrefillQuery as PersonalInformationPagePrefillQueryType } from 'src/clients/Network/gql/build/PersonalInformationPagePrefillQuery.graphql';
import LoadingPage from 'src/views/creditApplication/LoadingPage';

const PersonalInformationPagePrefillQuery = graphql`
  query PersonalInformationPagePrefillQuery {
    prefillIdentityDetails(q: {}) {
      data {
        id
        firstName
        lastName
        email
        e164
        dateOfBirth
        ssnLast4
      }
      errors
    }
  }
`;

const PersonalInformationPage = () => {
  const res = useLazyLoadQuery<PersonalInformationPagePrefillQueryType>(PersonalInformationPagePrefillQuery, {});
  const data = res.prefillIdentityDetails.data;

  const hasPrefilledData =
    data != null && !!data.firstName && !!data.lastName && !!data.email && !!data.e164 && !!data.dateOfBirth;
  return hasPrefilledData ? <PrefillInformationPage data={data} /> : <PartialPrefillInformationPage data={data} />;
};

const WithSuspense = () => {
  return (
    <React.Suspense fallback={<LoadingPage />}>
      <PersonalInformationPage />
    </React.Suspense>
  );
};

export default WithSuspense;
